import pick from 'lodash/pick';
import { GraphMode } from '../../constants';
import { Graph, TreeGraph, UpdateCommandParams } from '../../types';
import { BaseCommand, baseCommand } from '../base';

export const updateCommand: BaseCommand<UpdateCommandParams, Graph & TreeGraph> = {
  ...baseCommand,

  params: {
    id: '',
    originModel: {},
    updateModel: {},
    forceRefreshLayout: false,
  },

  canExecute(graph) {
    if (graph.getCurrentMode() === GraphMode.Readonly) return false;
    const selectedNodes = this.getSelectedNodes(graph);
    const selectedEdges = this.getSelectedEdges(graph);
    const canRun =
      (selectedNodes.length || selectedEdges.length) &&
      (selectedNodes.length === 1 || selectedEdges.length === 1);

    return !!canRun;
  },

  init(graph) {
    const { id, updateModel } = this.params;

    const updatePaths = Object.keys(updateModel);
    const originModel = pick(graph.findById(id).getModel(), updatePaths);

    this.params.originModel = originModel;
  },

  execute(graph) {
    const { id, updateModel, forceRefreshLayout } = this.params;

    graph.updateItem(id, updateModel);

    if (forceRefreshLayout && typeof graph.refreshLayout === 'function') {
      graph.refreshLayout(false);
    }
  },

  undo(graph) {
    const { id, originModel } = this.params;

    graph.updateItem(id, originModel);
  },
};

export default updateCommand;
